import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUser } from 'src/app/shared/models/auth-user.model';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  currentUser: AuthUser;

  constructor(private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    // Get authenticated user
    this.currentUser = JSON.parse(localStorage.getItem('gbi_auth_user'));
  }

  logout() {
    this.router.navigate(['/login']);
    // this.authService.logout();
  }
}
